import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../axios";
interface QuoteLinesReq {
  quoteLineId: number;
  vendorId: number;
  description?: string;
}
interface SaveQuoteReq {
  quoteReqId: number;
  quoteLines: QuoteLinesReq[];
}
const saveQuoteData = async (data: SaveQuoteReq[]) => {
  return await axiosInstance
    .patch("quotes/save", data)
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};

const useSaveQuoteData = () => {
  return useMutation({
    mutationFn: (data: SaveQuoteReq[]) => saveQuoteData(data),
    mutationKey: ["quotes"],
  });
};
export default useSaveQuoteData;
